export const ENUM_EVENT = {
    THEME: "THEME",
    LOADER: "LOADER",
    LOGOUT: "LOGOUT",
    SN_ACTIVATE: "SN_ACTIVATE",
    SNOE_ACTIVATE: "SNOE_ACTIVATE",
    INVALID_TOKEN: "INVALID_TOKEN"
}

export const sendDataToChild = ({ eventType, theme }) => {
    const event = new CustomEvent(eventType, {
        detail: theme
    });
    window.dispatchEvent(event);
};

